import { createContext } from 'react';
import { transformProperties } from 'remote-com-shared/domains/prismic/helpers';

export const LocalisedContentContext = createContext(
  transformProperties({
    form_success_thank_you: null,
    form_error_description: null,
    twoStep_form_title: null,
    twoStep_form_description: null,
    twoStep_form_next_page: null,
    twoStep_form_previous_page: null,
    twoStep_form_step_counter: null,
    contact_us_form_title: null,
    contact_us_form_description: null,
    contact_us_form_cta_label: null,
    contact_us_form_success_message: null,
  })
);
LocalisedContentContext.displayName = 'LocalisedContentContext';

export const LocalisedContentProvider = LocalisedContentContext.Provider;
export const LocalisedContentConsumer = LocalisedContentContext.Consumer;
